import React from 'react'
import PropTypes from 'prop-types'
import { Select as MaterialSelect, MenuItem, FormControl, InputLabel } from '@material-ui/core'

class Component extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <FormControl className={this.props.className} disabled={this.props.disabled}>
                <InputLabel>{this.props.label}</InputLabel>
                <MaterialSelect onChange={this.props.onChange} value={this.props.value}>
                    {this.props.menuItemList.map((elem) => (
                        <MenuItem value={elem.value} key={elem.value}>
                            {elem.display}
                        </MenuItem>
                    ))}
                </MaterialSelect>
            </FormControl>
        )
    }
}

Component.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    menuItemList: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
}

export const Select = Component
